import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { isAddress } from '../../utils/index.js'

const BAD_IMAGES = {}
const CUSTOM_TOKEN_LOGOS = {
  '0x4bdc4c23c0d9bdceefe9aab8d946da16b75e03fb': 'https://swap.aicchain.io/static/media/ethereum-logo.35926b13.png',
  '0xd359ebfa22d6cafe8ff49b9e45859f688243cdac':
    'https://swap.aicchain.io/assets/0xD359Ebfa22d6caFe8Ff49b9e45859F688243CdAC/logo.png',
}

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  min-width: ${({ size }) => size};
  min-height: ${({ size }) => size};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
`

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)
  const [sourceIndex, setSourceIndex] = useState(0)

  useEffect(() => {
    setError(false)
    setSourceIndex(0)
  }, [address])

  if (error || BAD_IMAGES[address]) {
    return (
      <Inline>
        <div
          {...rest}
          alt={''}
          style={{
            width: size,
            height: size,
            minWidth: size,
            minHeight: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size,
          }}
          role="img"
          aria-label="face"
        >
          🤔
        </div>
      </Inline>
    )
  }

  // hard coded fixes for trust wallet api issues
  if (address?.toLowerCase() === '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb') {
    address = '0x42456d7084eacf4083f1140d3229471bba2949a8'
  }

  if (address?.toLowerCase() === '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f') {
    address = '0xc011a72400e58ecd99ee497cf89e3775d4bd732f'
  }

  // prefer local project assets only to avoid noisy cross-origin 404s
  const checksummed = isAddress(address)
  const localBase = `${process.env.PUBLIC_URL || ''}/assets/${checksummed}`
  const customSource = address ? CUSTOM_TOKEN_LOGOS[address.toLowerCase()] : undefined
  const sources = customSource ? [customSource, `${localBase}/logo.png`] : [`${localBase}/logo.png`]

  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={sources[sourceIndex]}
        size={size}
        onError={(event) => {
          event.preventDefault()
          if (sourceIndex + 1 < sources.length) {
            setSourceIndex(sourceIndex + 1)
          } else {
            BAD_IMAGES[address] = true
            setError(true)
          }
        }}
      />
    </Inline>
  )
}
